import axios from 'axios';
import EventBus from 'src/components/EventBus.js'
var User = {};

var _baseURL = process.env.VUE_APP_AUTH_API + '/users'

User.install = function(Vue) {
  Vue.prototype.$user = {
    fetchMe(params) {
      axios({
        method: 'GET',
        url: _baseURL + '/me',
        params,
        withCredentials: true,
      }).then((response) => {
        EventBus.$emit('user-fetched', response.data)

        // Fetches if the user has any projects
        axios({
          method: 'GET',
          url: `${process.env.VUE_APP_ANALYTIC_SERVER}neo4j_querying/project/count/user`,
          withCredentials: true
        }).then((response) => {
          if(response?.data?.result > 0)
            EventBus.$emit('user-has-projects')
        })
      }, (error) => {
        if (error.response.status == 401) {
          EventBus.$emit('user-unauthorized')
        }
      });
    },
    submitUserUpdate(data) {
      axios({
        method: 'PATCH',
        url: _baseURL + '/update_me',
        data: { user: data },
        withCredentials: true,
      }).then((response) => {
        EventBus.$emit('data-submitted-sucessfully', response.data)
        EventBus.$emit('user-fetched', response.data)
      }, (error) => {
        if (error.response.status == 401) {
          EventBus.$emit('user-unauthorized')
        }
      });
    },
    signUp(params, afterSubmitSignup, afterSubmitSignupFailedUnexpectedly) {
      axios({
        method: 'POST',
        url: _baseURL,
        data: { user: params },
        withCredentials: true,
      }).then((response) => afterSubmitSignup(response), afterSubmitSignupFailedUnexpectedly);
    },
    logout() {
      axios({
        method: 'POST',
        url: _baseURL + '/logout',
        withCredentials: true,
      })
      localStorage.clear()
    },
    submitChangePassword(data) {
      axios({
        method: 'PATCH',
        url: _baseURL + '/change_password',
        data,
        withCredentials: true,
      }).then((response) => {
        EventBus.$emit('data-submitted-sucessfully', response.data)
      }, (error) => {
        if (error.response.status == 401) {
          EventBus.$emit('user-unauthorized')
        }
      });
    },

    activeAccount(activation, email, success, error) {
      axios({
        method: 'POST',
        url: _baseURL + '/activate',
        data: { activation, email }
      }).then(
        (response) => success(response),
        (e) => error(e)
      )
    },
    resendActivationCode(email, success, error) {
      axios({
        method: 'POST',
        url: _baseURL + '/resend_activation',
        data: { email }
      }).then(
        (response) => success(response),
        (e) => error(e)
      )
    },
    onboarding(email, activation, success) {
      axios({
        method: 'GET',
        url: _baseURL + '/onboarding',
        params: { email, activation }
      }).then(
        (response) => success(response.data)
      )
    },
    registerOnboarding(data, success, error) {
      axios({
        method: 'POST',
        url: _baseURL + '/register_onboarding',
        data: { user: data }
      }).then(
        success, error
      )
    },
    requestResetPassowrd(email, success, error) {
      var bodyFormData = new FormData();
      bodyFormData.append('email', email)
      axios({
        method: 'POST',
        url: _baseURL + '/forgot_password',
        data: bodyFormData,
      }).then(
        (response) => success(response),
        (e) => error(e)
      )
    }
  }
}
export default User;
